import React from "react";
import ProductGallery from "../../GalleryImagesComponent";
import Image1 from "../../../../Product/School_Uniforms/Polos_T-Shirts/PT1.webp";
import Image2 from "../../../../Product/School_Uniforms/Polos_T-Shirts/PT2.webp";
import Image3 from "../../../../Product/School_Uniforms/Polos_T-Shirts/PT3.webp";
import Image4 from "../../../../Product/School_Uniforms/Polos_T-Shirts/PT4.webp";
import Image5 from "../../../../Product/School_Uniforms/Polos_T-Shirts/PT5.webp";
import Image6 from "../../../../Product/School_Uniforms/Polos_T-Shirts/PT6.webp";
import Image7 from "../../../../Product/School_Uniforms/Polos_T-Shirts/PT7.webp";
import Image8 from "../../../../Product/School_Uniforms/Polos_T-Shirts/PT8.webp";
import Image9 from "../../../../Product/School_Uniforms/Polos_T-Shirts/PT9.webp";
import Image10 from "../../../../Product/School_Uniforms/Polos_T-Shirts/PT10.webp";

const PolosTShirts = () => {
  const images = [Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8, Image9, Image10];

  return (
    <ProductGallery
      images={images}
      category={{ english: "school_uniform", enName: "Educational", arabic: "التعليم", arName: "التعليم" }}
      product={{ english: "Polos T-Shirts", arabic: "تيشرتات بولو" }}
    />
  );
};

export default PolosTShirts;
